    // 点击卖点服务弹出弹窗
    jQuery('.seller_guarantee').find('li').each(function(index){
      jQuery(this).off("click").on("click",function(){
        sales_service_popup(index);
      })
    })

   function popon6(index){
      sales_service_popup();

    
   }
// 买点服务弹窗
function sales_service_popup(index){
 var sales_service_html='<div class="window-cover" style=""></div>'+
 '<div class="pop_main">'+
       '<div class="pop_con">'+
           '<div class="pop_title">'+
               '<div class="pop_title_left"></div>'+
               '<button type="button" class="window-cover_con-close iconfont icon-x-close"></button>'+
           '</div>'+
         '<div class="pop_detail">'+
           '<ul class="sales_service_popup_title">'+
             '<li class="active">72-Hrs Delivery</li>'+
             '<li>30 Days Free Return</li>'+
             '<li>Buy Later</li>'+
           '</ul>'+
           '<ul class="sales_service_popup_con">'+
             '<li class="active"><p>Sunber Hair is committed to providing customers with a fast and convenient shopping experience. We have self-operated uswarehouse in Atlanta and California, and it only takes 24-72hours from placing order to receiving.</p> us Orders will Be Shipped From Our Us warehouse Within 2-4 Business Days By USPS | UPS</p> <p>Other Orders will Be Shipped From Our China WarehouseWithin 5-7 Business Das B DHL UPS ITNT I FedEx.</p></li>'+
             '<li><p>Sunber Hair has been committed to providing consumers with the best quality weave hair & 100% human hair wigs since the start of the company. Also, we want our customers to behappy with their purchases.</p> <p> If you are not 100% satisfied, all online purchases made through sunberhair.com are eligible for an exchangeor return within 30 days of the date you received the item</p><p> Please check our return & exchange policy.</p> Note: Items must be returned unused. undamaged and withoriginal tags and packaging.</li>'+
             '<li>'+
               '<div class="buy_later_cen">'+
                 '<h5>Buy Now Pay Later: </h5>'+
                 '<div class="fenqi_icon buy_later_list">'+
                   '<img src="https://cdn.shopify.com/s/files/1/1720/3969/files/Frame_1321318456.png?v=1720071984" alt="" width="93" height="43" >'+
                   '<img src="https://cdn.shopify.com/s/files/1/1720/3969/files/afterpay_e97e1c82-4d88-4666-b53f-79b03fdba4cd.png?v=1745286158" alt="" width="93" height="43" >'+
                   '<img src="https://cdn.shopify.com/s/files/1/1720/3969/files/Vector-1.png?v=1720071984" alt="" width="93" height="43" >'+
                   '<img src="https://cdn.shopify.com/s/files/1/1720/3969/files/Frame_1321319835.png?v=1720071984" alt="" width="93" height="43" >'+
                 '</div>'+
                 '<h5>Buy Now Pay Later: </h5>'+
                 '<div class="buy_later_list">Master, Visa, American Express or Discover. Buy now and pay later.</div>'+
                 '<h5 class="last_title_word">Pay in 4 interest-free payments. </h5>'+
                 '<div class="buy_later_list">(You must be at least 18 years old, and meet other eligibility criteria to be eligible. Late fees may apply. The estimated payment amount shown on the product page doesn’t include taxes and shipping fees, which will be added at checkout.)</div>'+
               '</div>'+
             '</li>'+
           '</ul>'+
 
         '</div>'+
       '</div>'+
 '</div>'
 $('.sales_service_popup').append(sales_service_html);
     $('.sales_service_popup_title li').eq(index).addClass('active').siblings().removeClass('active');
     $('.sales_service_popup_con li').eq(index).addClass('active').siblings().removeClass('active');
     jQuery('.sales_service_popup .window-cover').show();
     jQuery('.sales_service_popup .pop_main').show();
     jQuery('.sales_service_popup .pop_main .pop_con').css({'top':0,'opacity':0});
     jQuery('.sales_service_popup .pop_main .pop_con').animate({'top':'50%','opacity':1});
      var scrollTop = $(window).scrollTop();
     $('body').attr('data-overflow-top',scrollTop);
      $('body').css({
        'overflow': 'hidden',
        'position': 'fixed',
        'top': '-' + scrollTop + 'px',
        'left': '0',
        'right': '0',
        'bottom': '0'
      });
   // 卖点服务tab切换
   jQuery(".sales_service_popup .sales_service_popup_title li").off("click").on("click",function(){
     tab_change(jQuery(this));
   })
   jQuery('.sales_service_popup .window-cover_con-close').click(function(){
   sales_service_close();
 })
}
// tab切换
function tab_change(item){
 item.addClass('active') // 返回 item
 .siblings() // 返回ul下li的兄弟
 .removeClass('active') // 返回ul下li的兄弟
 .parent() // 返回ul
 .next() // 返回ol
 .children() // 返回ol下所有li
 .eq(item.index()) // 返回ol下的一个li
 .addClass('active') // 返回ol下的一个li
 .siblings() // 返回ol下li的兄弟
 .removeClass('active') // 返回ol下li的兄弟
}
function sales_service_close() {
     jQuery('.sales_service_popup .window-cover').hide();
    jQuery('.sales_service_popup .pop_main').hide();
    jQuery('.sales_service_popup .pop_main .pop_con').css({'top':'50%','opacity':1});
    jQuery('.sales_service_popup .pop_main .pop_con').animate({'top':'0','opacity':0});
    $('.sales_service_popup').html('');
          $('body').css({
              'overflow': '',
              'position': '',
              'top': '',
              'left': '',
              'right': '',
              'bottom': ''
            });
            var scrollTop = $('body').attr('data-overflow-top');
            $(window).scrollTop(scrollTop);
}